import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { SelectItem } from '../../../shared/efaact-primeng.module';
import * as FacilityAllocationActions from './facility-allocation.actions';
import { FacilityAllocation } from './facility-allocation.model';

export const facilityAllocationsFeatureKey = 'facilityAllocations';

export interface State extends EntityState<FacilityAllocation> {
    facilityAllocationTypes: SelectItem[];
}

export const adapter: EntityAdapter<FacilityAllocation> =
    createEntityAdapter<FacilityAllocation>();

export const initialState: State = adapter.getInitialState({
    facilityAllocationTypes: []
});

const facilityAllocationReducer = createReducer(
    initialState,
    on(FacilityAllocationActions.addFacilityAllocation, (state, action) =>
        adapter.addOne(action.facilityAllocation, state)
    ),
    on(FacilityAllocationActions.upsertFacilityAllocation, (state, action) =>
        adapter.upsertOne(action.facilityAllocation, state)
    ),
    on(FacilityAllocationActions.addFacilityAllocations, (state, action) =>
        adapter.addMany(action.facilityAllocations, state)
    ),
    on(FacilityAllocationActions.upsertFacilityAllocations, (state, action) =>
        adapter.upsertMany(action.facilityAllocations, state)
    ),
    on(FacilityAllocationActions.updateFacilityAllocation, (state, action) =>
        adapter.updateOne(action.facilityAllocation, state)
    ),
    on(FacilityAllocationActions.updateFacilityAllocations, (state, action) =>
        adapter.updateMany(action.facilityAllocations, state)
    ),
    on(FacilityAllocationActions.deleteFacilityAllocation, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(FacilityAllocationActions.deleteFacilityAllocations, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(FacilityAllocationActions.loadFacilityAllocations, (state, action) =>
        adapter.setAll(action.facilityAllocations, state)
    ),
    on(FacilityAllocationActions.clearFacilityAllocations, state =>
        adapter.removeAll(state)
    ),
    on(
        FacilityAllocationActions.loadFacilityAllocationTypes,
        (state, action) => ({
            ...state,
            facilityAllocationTypes: action.facilityAllocationTypes
        })
    )
);

export function reducer(state: State | undefined, action: Action) {
    return facilityAllocationReducer(state, action);
}
